import { render, staticRenderFns } from "./HeadlineCanvas.vue?vue&type=template&id=a633ac80&scoped=true&"
import script from "./HeadlineCanvas.vue?vue&type=script&lang=js&"
export * from "./HeadlineCanvas.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineCanvas.vue?vue&type=style&index=0&id=a633ac80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a633ac80",
  null
  
)

export default component.exports